// extracted by mini-css-extract-plugin
export default {"video":"g2yZI","video-player":"bKGJM"};